import React from "react";
import { MoreVertical, Eye, Pencil, Copy, Archive, Trash2, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

/**
 * Three-dot (⋮) row action menu. Pass only the handlers you need; items render conditionally.
 * onView, onEdit, onDuplicate, onArchive, onRestore, onPermanentDelete
 */
export function RowActions({ onView, onEdit, onDuplicate, onArchive, onRestore, onPermanentDelete, testId = "row" }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" data-testid={`${testId}-actions-trigger`} aria-label="Aksi">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {onView && <DropdownMenuItem onClick={onView} data-testid={`${testId}-action-view`}><Eye className="h-4 w-4 mr-2" />Lihat</DropdownMenuItem>}
        {onEdit && <DropdownMenuItem onClick={onEdit} data-testid={`${testId}-action-edit`}><Pencil className="h-4 w-4 mr-2" />Edit</DropdownMenuItem>}
        {onDuplicate && <DropdownMenuItem onClick={onDuplicate} data-testid={`${testId}-action-duplicate`}><Copy className="h-4 w-4 mr-2" />Duplikat</DropdownMenuItem>}
        {onRestore && <DropdownMenuItem onClick={onRestore} data-testid={`${testId}-action-restore`}><RotateCcw className="h-4 w-4 mr-2" />Pulihkan</DropdownMenuItem>}
        {(onArchive || onPermanentDelete) && (onView || onEdit || onDuplicate || onRestore) && <DropdownMenuSeparator />}
        {onArchive && <DropdownMenuItem onClick={onArchive} className="text-destructive focus:text-destructive" data-testid={`${testId}-action-archive`}><Archive className="h-4 w-4 mr-2" />Arsipkan</DropdownMenuItem>}
        {onPermanentDelete && <DropdownMenuItem onClick={onPermanentDelete} className="text-destructive focus:text-destructive" data-testid={`${testId}-action-permanent-delete`}><Trash2 className="h-4 w-4 mr-2" />Hapus Permanen</DropdownMenuItem>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
